<div #scrollTarget></div>
<div class="container-fluid mt-4">
    <h4 class="mb-3 "><i class="fi fi-rr-newspaper"></i> სტატიები <span *ngIf="currentLang == 'en'">(EN)</span> </h4>
    <div class="row">
        <div class="col-md-3">
        <select [(ngModel)]="selectedItem" class="form-select mb-3 " (change)="onPageChange()" >
            <option  *ngFor="let itm of selectedItems" [ngValue]="itm.slug">{{ itm.title }}</option>
        </select>
        </div>
        <div class="col-md-3"> 
          <button class="btn btn-primary" (click)="openPost()">
              დამატება 
          </button>
        </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-4">
      <input 
        type="text" 
        [(ngModel)]="search" 
        class="form-control"
        (ngModelChange)="getPageByItems()" 
        placeholder="ძიება..." />
    </div>
  
    </div>

    

    <div class="row g-4">
      <app-spinner [loading]="loaddata" text="იტვირთება..."></app-spinner>
    </div>

    <div *ngIf="!loaddata && (!data.items || data.items.length === 0)">
      ინფორმაცია ცარიელია
    </div>

    <div class="table-responsive">
      <table class="table table-bordered table-hover" *ngIf="data?.items?.length">
        <thead>
          <tr>
            <th>#</th>
            <th>სურათი</th>
            <th (click)="sortData('title')" style="cursor:pointer">
              სათაური
              <span *ngIf="sortColumn === 'title'">
                {{ sortDirection === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th (click)="sortData('postdate')" style="cursor:pointer">
              დამატების თარიღი
              <span *ngIf="sortColumn === 'postdate'">
                {{ sortDirection === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th (click)="sortData('visibility')" style="cursor:pointer">
              გამოჩენა
              <span *ngIf="sortColumn === 'visibility'">
                {{ sortDirection === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th>ქმედებები</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of data.items; let i = index">
            <td>{{ (page - 1) * perPage + i + 1 }}</td>
            <td>
              <img
                *ngIf="item.image1 && item.image1.trim() !== ''"
                [src]="getFullImageUrl(item.image1)"
                class="square-img"
              />
            </td>            
            <td class="truncate-text">{{ item.title }}</td>
            <td>{{ item.postdate || item.created_at | date: 'dd MMM yyyy, HH:mm' }}</td>
            <td>
              <span class="text-success" *ngIf="item.visibility == 1">ჩანს</span>
              <span class="text-danger" *ngIf="item.visibility == 0">არჩანს</span>
            </td>
            <td>
              <div class="d-flex">

                <button class="btn btn-sm border rounded d-flex align-items-center mx-2" (click)="editPage(item)">
                  <i class="fi fi-rr-pencil"></i>
                </button> 

                <a class="btn btn-sm border rounded d-flex align-items-center mx-2" *ngIf="selectedMenuSource == 'pages'"
                 href="{{defaultDomain}}page/{{item.slug}}" target="_blank">
                  <i class="fi fi-rr-eye text-info"></i>
                </a> 

                <a class="btn btn-sm border rounded d-flex align-items-center mx-2" *ngIf="selectedMenuSource == 'catalogs'" 
                href="{{defaultDomain}}catalog/{{item.slug}}/{{item.id}}" target="_blank">
                  <i class="fi fi-rr-eye text-info"></i>
                </a> 
                  
                <button class="btn btn-sm border rounded d-flex align-items-center mx-2" (click)="delete(item, data.source)">
                  <i class="fi fi-rr-trash text-danger"></i>
                </button> 

              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <nav *ngIf="data?.pagination?.last_page > 1" class="mt-3">
        <ul class="pagination justify-content-center">
          <!-- Previous button -->
          <li class="page-item" [class.disabled]="page === 1">
            <button class="page-link" (click)="changePage(page - 1)" [disabled]="page === 1">&laquo;</button>
          </li>

          <!-- First page -->
          <li class="page-item" [class.active]="page === 1">
            <button class="page-link" (click)="changePage(1)">1</button>
          </li>

          <!-- Dots before current range -->
          <li class="page-item disabled" *ngIf="page > 4">
            <span class="page-link">...</span>
          </li>

          <!-- Pages around current -->
          <ng-container *ngFor="let i of [].constructor(data.pagination.last_page); let index = index">
            <ng-container *ngIf="index + 1 > 1 && index + 1 < data.pagination.last_page &&
                                index + 1 >= page - 1 && index + 1 <= page + 1">
              <li class="page-item" [class.active]="page === index + 1">
                <button class="page-link" (click)="changePage(index + 1)">{{ index + 1 }}</button>
              </li>
            </ng-container>
          </ng-container>

          <!-- Dots after current range -->
          <li class="page-item disabled" *ngIf="page < data.pagination.last_page - 3">
            <span class="page-link">...</span>
          </li>

          <!-- Last page -->
          <li class="page-item" [class.active]="page === data.pagination.last_page">
            <button class="page-link" (click)="changePage(data.pagination.last_page)">
              {{ data.pagination.last_page }}
            </button>
          </li>

          <!-- Next button -->
          <li class="page-item" [class.disabled]="page === data.pagination.last_page">
            <button class="page-link" (click)="changePage(page + 1)" [disabled]="page === data.pagination.last_page">&raquo;</button>
          </li>
        </ul>
      </nav>
    </div>

    
</div>

<ng-template #postFormModal>
  <app-page-form-modal
    [menuid]="selectedMenuType"
    [isPost]="true"
    [initialData]="selectedPost"
    (save)="onPostSaved()"
    (closeModal)="onCloseModal()"
  ></app-page-form-modal>
</ng-template>



<ng-template #postCatalogFormModal>
  <app-catalog-form-modal
    [menuid]="selectedMenuType"
    [initialData]="selectedPost"
    (save)="onCatalogSaved()"
    (closeModal)="onCloseModal()"
  ></app-catalog-form-modal>
</ng-template>